import { z } from "zod";
import type { Unit} from "./unit";
import { units, unitZodSchema } from "./unit";

type Amount = {
    unit: Unit;
    /**
     * Quantity of the unit.
     * E.g. 5 kg, 2 pcs, 50 cl, 4 l
     * @type {number}
     */
    value: number;
    /**
     * Number of items of the unit and unit value \
     * E.g. If the quantity is set to 10 and the value is set to 5 then: \
     * 10 x 5 kg, 10 * 5 pcs, 10 x 5 cl, 10 x 5 l \
     *
     * Usually left blank and hence set to 1. \
     * Can be used for selling items in bulk. \
     * Like for example: 4 x 4 pack of socks
     *
     * Defaults to 1!
     * @type {number}
     */
    quantity?: number;
};

const defaultAmount: Amount = { value: 1, unit: units.pcs, quantity: 1 };

const amountFactory = (input: {
    unit: Amount["unit"];
    value: Amount["value"];
    quantity: Amount["quantity"];
}): Amount => {
    const { unit, value, quantity } = input;
    return {
        unit,
        value,
        quantity: quantity || 1,
    };
};
const amountZodSchema: z.ZodSchema<Amount> = z.object({
    unit: unitZodSchema,
    value: z.number().min(0),
    quantity: z.number().min(1).optional().default(1),
});

export { amountFactory, defaultAmount, amountZodSchema };
export type { Amount };

